import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Path } from 'core/constants/path.constants';
import { ESuggestedProductViewId } from 'core/model/enums/catalog.enum';
import { authChannelSelector } from 'core/store/auth/selectors';
import { getCustomizationElementsAction } from 'core/store/customization';
import { useAppDispatch, useAppSelector } from 'core/store/store.utils';
import { getSuggestedProducts } from 'core/store/suggested-products';

const useInitializeHome = (customerId?: number) => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const mounted = useRef(false);
  const previousCustomerId = useRef(customerId);
  const channel = useAppSelector(authChannelSelector);

  useEffect(() => {
    const isHomePath = pathname === Path.HOME;
    const hasCustomerChanged = previousCustomerId.current !== customerId;

    if (customerId && isHomePath) {
      if (!mounted.current || hasCustomerChanged) {
        dispatch(getCustomizationElementsAction());
        mounted.current = true;
        previousCustomerId.current = customerId;
      }

      dispatch(getSuggestedProducts({ sectionId: ESuggestedProductViewId.homepage }));
    }
  }, [customerId, dispatch, pathname, channel?.id]);
};

export default useInitializeHome;
